import React from 'react';

import AccordionItem from './AccordionItem/AccordionItem';

import classes from './Accordion.module.css';
import { IsListEmpty } from '../../../utilities/CommonMethods';
import EditQuizQuestionForm from '../../Forms/QuizQuestionForm/QuizQuestionForm';

const accordion = (props) => {

    let styleCalsses = [classes.AccordionList];

    return (
        <div className={classes.Wrapper} >
            <ul className={styleCalsses.join(' ')} >
                {
                    !IsListEmpty(props.data) ? props.data.map((data, pos) => {
                        return (
                            <li className={classes.AccordionListItem} key={pos} >
                                {data.showEditForm === true
                                    ? <EditQuizQuestionForm
                                        pos={pos}
                                        data={data}
                                        forEdit={true}
                                        hideEditForm={props.hideEditForm}
                                        editQuizQuesitonClicked={props.editQuizQuesitonClicked}
                                        showSessionExpiredDialog={props.showSessionExpiredDialog}
                                        redirectToUnauthorized={props.redirectToUnauthorized}
                                        onFailureDialogShow={props.onFailureDialogShow}
                                        showContentLoader={props.showContentLoader} />
                                    : <AccordionItem
                                        problemData={data}
                                        pos={pos}
                                        collapseAll={props.collapseAll}
                                        questionType={data.type}
                                        forPMPage={props.forPMPage}
                                        forInstructor={props.forInstructor}
                                        onEditProblemClick={props.onEditProblemClick}
                                        onDeleteProblemClick={props.onDeleteProblemClick}
                                    />}
                            </li>
                        )
                    }) : null
                }
            </ul>
        </div>
    );
}

export default accordion;